import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { EditService } from '../../../../services/index';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import * as moment from 'moment';
import { SOAAddEditComponent } from './addeditsoa.component';
@Component({
    selector: 'edit-tab',
    templateUrl: './soaedit.component.html',
})
export class SOAEditComponent implements OnInit {
    columns: any[];
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    editsoadata: any;
    totcount: number;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date()
    };
    page = {
        limit: 25,
        count: 0,
        offset: 0,
    };
    loadingIndicator: boolean = true;
    isLoadMask: Promise<any>;
    constructor(public editservice: EditService, private modalService: BsModalService) {

    }
    ngOnInit() {
        this.columns = [
            { name: 'Branch', prop: 'branch', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Client Name', prop: 'name', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'phone', prop: 'mobile', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Appointment Date', prop: 'apdate', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Soa/Soa Retrail', prop: 'lstatus', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Testing', prop: 'testingtype', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Compination', prop: 'compination', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Travel Expence', prop: 'travel_expense', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Outstatus', prop: 'ostatus', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Action', prop: 'sno', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellTemplate: this.editDeleteTemplate }

        ];
        this.getSoaList();
        this.pageCallback({ offset: 0 });

    }
    applyFilter() {
        this.getSoaList();
        this.filterPanel.close();

    }
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getSoaList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getSoaList();
    }
    getSoaList() {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
        };
        let that = this;
        this.isLoadMask = this.editservice
            .getsoaeditlist(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.editsoadata = res.data;
                that.page.count = res.totCnt;
            });
    }
    bsModalRef: BsModalRef;
    edithventry(mode, row) {
        this.bsModalRef = this.modalService.show(SOAAddEditComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-80'
        });
        this.bsModalRef.content.editSoaData = Object.assign({}, row);
        this.bsModalRef.content.soaDataLoadEvent.subscribe(($e) => {
            this.getSoaList();
        })
    }

}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/Edit/soaedit/soaedit.component.ts